import CourseList from "./CourseList";
import { Route } from "react-router-dom";
import { TYPE_ARTICLE } from "./courseTypes";
import { BreadCrumb } from "../../../components/main/LayoutComponents";
import { Locale } from "../../../utils";
import CourseStudentList from "../students/StudentList";
import AddOrEditCourse from "./AddOrEditCourse";
const i18n = Locale.getInstance();

const ArticleCourseList = () => {
  const breadCrumbData = [
    {
      href: "/main/courses/article-courses",
      title: i18n.t("course.titleArticle"),
    },
  ];
  return (
    <div className="course">
      <BreadCrumb data={breadCrumbData} />
      <CourseList type={TYPE_ARTICLE} />
    </div>
  );
};

const CourseListCompact = ({ match }) => {
  return (
    <>
      <Route exact path={`${match.path}`} component={ArticleCourseList} />
      <Route path={`${match.path}/students`} component={CourseStudentList} />
      <Route path={`${match.path}/edit`} component={AddOrEditCourse} />
    </>
  );
};

export default CourseListCompact;
